import { rem } from 'polished';
import styled, { css } from 'styled-components';

import { Tag } from '@vimeo/bokeh';
import { red, slate, grayscale } from '@vimeo/iris/color';
import { Button } from '@vimeo/iris/components';

const BreakPoints = {
  xs: 320,
  xsm: 375,
  xmd: 480,
  sm: 768,
  md: 1024,
  lg: 1280,
  hd: 1440,
  xhd: 1920,
};

const media: any = Object.keys(BreakPoints).reduce((accumulator, label) => {
  const pxSize = (BreakPoints as any)[label];
  (accumulator as any)[label] = (arg: TemplateStringsArray, ...args: TemplateStringsArray[]) => css`
    @media (min-width: ${pxSize}px) {
      ${css(arg, ...args)};
    }
  `;
  return accumulator;
}, {});

const ModalContentWrapper = styled.div`
  ${media.xs`
    width: ${rem(240)};
  `}
  ${media.sm`
    width: ${rem(360)};
  `}
`;

const ShareModalWrapper = styled.div`
  ${media.md`
    display: inline-block;
  `}
`;

const CaptchaWrapper = styled.div`
  padding-bottom: ${rem(20)};
  min-height: ${rem(85)};
  ${media.xs`
    transform: scale(0.79);
    transform-origin: 0 0;
  `}
  ${media.sm`
    transform: none;
  `}
`;

const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const ButtonMargin = styled(Button)`
  margin-right: ${rem(6)};
`;

const CopyFieldWrapper = styled.div`
  padding-bottom: ${rem(24)};
  border-bottom: ${rem(1)} solid ${slate(200)};
`;

const EmailFieldWrapper = styled.div`
  padding-top: ${rem(24)};
`;

const MessageFieldWrapper = styled.div`
  padding: ${rem(24)} 0;
`;

const ErrorMsg = styled.span`
  color: ${red(600)};
  font-size: ${rem(12)};
`;

const EmailInputWrapper = styled.div`
  margin-bottom: ${rem(8)};
`;

const EmailTag = styled(Tag)`
  margin-bottom: ${rem(8)};
  display: inline-flex;
  color: ${grayscale(800)};
  &:not(:last-child) {
    margin-right: ${rem(8)};
  }
`;

export {
  ShareModalWrapper,
  ModalContentWrapper,
  ButtonsWrapper,
  ButtonMargin,
  EmailInputWrapper,
  EmailTag,
  ErrorMsg,
  CopyFieldWrapper,
  EmailFieldWrapper,
  MessageFieldWrapper,
  CaptchaWrapper,
};
